<template>
    <div id="api" class="section">
        <h1 class="sub-header">{{ $t("api.sub-header-part-1") }}<span class="header-dot">{{ $t("api.sub-header-part-2") }}</span></h1>
        <div class="content">
            <div class="alternating-display">
                <div class="flavour-text">
                    <div class="flavour-description">
                        <p>{{ $t("api.content-1.paragraph.line-1") }}</p>
                        <br>
                        <p>
                            <span>{{ $t("api.content-1.paragraph.line-2-1") }}</span>
                            <a href="https://documenter.getpostman.com/view/22972506/2sAXqwYzuo"> Rest API </a>
                            <span>{{ $t("api.content-1.paragraph.line-2-2") }}</span>
                            <a href="https://documenter.getpostman.com/view/22972506/2sAXjNWq6w"> Billing API </a>
                            <span>{{ $t("api.content-1.paragraph.line-2-3") }}</span>
                        </p>
                        <!-- <br> -->
                        <!-- <a href="https://documenter.getpostman.com/view/22972506/2sAXqwYzuo">Link na dokumentaciju</a> -->
                    </div>
                </div>
                <div class="displayed-item">
                    <img class="shrinking-image" src="../../../assets/images/logos/m2pay-octagon.png" alt="">
                    <p class="inspect-text top-left-horizontal">
                        <span>{{ $t("api.content-1.icon-infos.info-1") }}</span>
                        <br>
                        <span>{{ $t("api.content-1.icon-infos.info-2") }}</span>
                    </p>
                    <!-- <p class="inspect-text top-right-diagonal">
                        <span class="model-name">INTUITIVNO S</span>
                    </p> -->
                </div>
            </div>
            <div class="alternating-display alter">
                <div class="flavour-text">
                    <div class="flavour-description">
                        <p>
                            <span>{{ $t("api.content-2.paragraph.line-1-1") }}</span>
                            <a href="https://documenter.getpostman.com/view/22972506/2sAXxJhaDm"> Crypto API </a>
                            <span>{{ $t("api.content-2.paragraph.line-1-2") }}</span>
                        </p>
                        <br>
                        <p>
                            <span>{{ $t("api.content-2.paragraph.line-2-1") }}</span>
                            <a href="https://developer-ecomm.handpoint.com/docs/overview"> E-Commerce API </a>
                            <span>{{ $t("api.content-2.paragraph.line-2-2") }}</span>
                        </p>
                    </div>
                </div>
                <div class="displayed-item">
                    <img class="shrinking-image" src="../../../assets/images/logos/m2pay-octagon.png" alt="">
                    <p class="inspect-text top-left-horizontal">
                        <span>{{ $t("api.content-2.icon-infos.info-1") }}</span>
                        <br>
                        <span>{{ $t("api.content-2.icon-infos.info-2") }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>